import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Soldás pero sin técnica real — aprendiste solo y tenés vicios que no sabés corregir', 'Cuando llega un trabajo difícil dudás si aceptarlo porque no sabés si podés', 'No sabés cómo costear bien un trabajo y terminás cobrando menos de lo que vale', 'Querés fabricar trailers o máquinas de GYM pero no tenés los planos ni el proceso', 'Cada semana te decís "esta semana organizo el taller" y no pasa nada', 'Ves a otros herreros cobrar el doble y no entendés qué hacen diferente', 'Tenés habilidad pero no sabés cómo conseguir más clientes ni cómo cerrar ventas', 'Sentís que tu taller podría darte mucho más dinero del que te da hoy'];
  return <section className="py-20 bg-black" data-id="element-250">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-252">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-253">
            ¿Cuántas oportunidades más vas a dejar pasar por no tener el sistema
            correcto?
          </h2>

          <div className="space-y-6 text-lg text-zinc-200 text-left md:text-center max-w-3xl mx-auto" data-id="element-254">
            <p className="text-[14px]" data-id="element-255">
              Tal vez ya miraste videos sueltos de YouTube que no tienen orden
              ni progresión. Tal vez hiciste algún curso que era demasiado
              teórico y no aplicaba al taller real. Tal vez llevás años
              trabajando pero sentís que tu taller no crece como debería.
            </p>
            <p data-id="element-256">
              <strong className="text-white text-[16px]" data-id="element-257">
                No es falta de talento. Es que nadie te dio el sistema completo
                para herreros argentinos.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/60 rounded-2xl p-6 md:p-8" data-id="element-258">
          <ul className="space-y-4" data-id="element-259">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-260">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-261">
                  <X className="w-4 h-4 text-red-400" data-id="element-262" />
                </div>
                <span className="text-zinc-100 font-medium text-[14px]" data-id="element-263">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-264">
          <p className="font-bold text-amber-400 text-[16px]" data-id="element-265">
            ¿Y si esta fuera la última semana que dejás pasar esta oportunidad?
          </p>
        </div>
      </div>
    </section>;
}